"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundedEventQueue = void 0;
const application_logger_1 = require("../application-logger");
const constants_1 = require("../constants");
/** A bounded event queue that drops events when it reaches its maximum size. */
class BoundedEventQueue {
    constructor(name, queue = new Array(), maxSize = constants_1.MAX_EVENT_QUEUE_SIZE) {
        this.name = name;
        this.queue = queue;
        this.maxSize = maxSize;
    }
    get length() {
        return this.queue.length;
    }
    splice(count) {
        return this.queue.splice(count);
    }
    isEmpty() {
        return this.queue.length === 0;
    }
    [Symbol.iterator]() {
        return this.queue[Symbol.iterator]();
    }
    push(...events) {
        const { name, maxSize, queue } = this;
        while (queue.length < maxSize && events.length > 0) {
            queue.push(...events.splice(0, 1));
        }
        if (events.length > 0) {
            application_logger_1.logger.warn(`Dropping ${events.length} events for queue ${name} since maxSize of ${maxSize} reached.`);
        }
    }
    /** Clears all events in the queue and returns them in insertion order. */
    flush() {
        const events = [...this.queue];
        this.queue.length = 0;
        return events;
    }
}
exports.BoundedEventQueue = BoundedEventQueue;
//# sourceMappingURL=bounded-event-queue.js.map